import styles from './EventDateTimePicker.module.scss';

import EventDatePicker from 'Screens/Dashboard/Events/EventHandler/inputs/EventPeriod/EventDateTimePicker/EventDatePicker/EventDatePicker';
import EventTimePicker from 'Screens/Dashboard/Events/EventHandler/inputs/EventPeriod/EventDateTimePicker/EventTimePicker/EventTimePicker';
import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventDateTimePicker = () => {
    const { values } = useEventContext();
    const { allDay } = values;

    return (
        <div className={styles.container}>
            <EventDatePicker />
            {!allDay && <EventTimePicker />}
        </div>
    );
};

export default EventDateTimePicker;
